var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Select", {
    attrs: {
      value: _vm.value,
      "allow-clear": "",
      "show-search": "",
      "label-in-value": _vm.labelInValue,
      "filter-option": false,
      loading: _vm.loading,
      disabled: _vm.disabled,
      "dropdown-match-select-width": false,
      options: _vm.options,
      placeholder: _vm.$t("lbl_select_x", { x: _vm.$t("lbl_chart_of_account") })
    },
    on: {
      search: _vm.onSearch,
      change: _vm.onChange,
      scrollEnd: _vm.onScrollEnd
    },
    scopedSlots: _vm._u([
      {
        key: "option",
        fn: function(ref) {
          var option = ref.option
          return [_vm._v(" " + _vm._s(option.label) + " ")]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }